import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone } from "lucide-react";
import { BRAND } from "../../lib/brand";

export default function StickyMobileCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="lg:hidden fixed bottom-4 inset-x-4 z-40"
          data-testid="sticky-mobile-cta"
        >
          <a
            href={BRAND.phoneHref}
            data-testid="sticky-mobile-cta-link"
            className="btn-gold flex items-center justify-center gap-3 py-4 rounded-full text-[12px] uppercase tracking-[0.24em] font-medium shadow-[0_20px_60px_-20px_rgba(63,63,37,0.55)]"
          >
            <Phone className="h-4 w-4" strokeWidth={1.6} />
            Réserver ma séance
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
